<template>
    <el-dialog
        v-if="isDialogVisible"
        :visible="true"
        @close="onFormClose"
        title="New Message"
    >
        <loading v-if="isBusy"></loading>
        <component
            v-if="!isBusy"
            :is="currentComponent"
            :contact-search-url="contactSearchUrl"
            :store-url="storeQuickMessageUrl"
            :outgoing-numbers="outgoingNumbers"
            @created="onMessageCreated"
            @change-mode="onChangeMode"
        >
        </component>
    </el-dialog>
</template>

<script>
  import eventBus from "../event-bus";
  import FormExistingContact from "./form-existing-contact";
  import FormNewContact from "./form-new-contact";
  import Loading from "../components/loading";
  import {modes} from "./types";

  export default {
    components: {
      'form-existing-contact': FormExistingContact,
      'form-new-contact': FormNewContact,
      Loading,
    },

    props: {
      contactSearchUrl: String,
      outgoingNumberSearchUrl: String,
      storeQuickMessageUrl: String,
    },

    data() {
      return {
        currentComponent: 'form-existing-contact',
        isDialogVisible: false,
        isBusy: true,
        outgoingNumbers: [],
      };
    },

    methods: {
      /**
       * @return {undefined}
       */
      showForm() {
        this.isDialogVisible = true;
        this.currentComponent = 'form-existing-contact';
        this.getOutgoingNumbers()
          .then(() => {
            this.isBusy = false;
          });
      },

      /**
       * @return {undefined}
       */
      onFormClose() {
        this.destroyForm();
      },

      /**
       * @return {undefined}
       */
      destroyForm() {
        this.isBusy = true;
        this.isDialogVisible = false;
      },

      /**
       * @param {object} model
       * @param {String} message
       */
      onMessageCreated({model, message}) {
        this.destroyForm();
        this.$message.success(message);
        eventBus.$emit('quick-message-sent', model);
      },

      /**
       * @return {undefined}
       */
      onChangeMode(mode) {
        switch (mode) {
          case modes.create_send:
            this.currentComponent = 'form-new-contact';
            break;
          case modes.find_send:
            this.currentComponent = 'form-existing-contact';
            break;
        }
      },

      /**
       * @return {Promise}
       */
      getOutgoingNumbers() {
        return axios.get(this.outgoingNumberSearchUrl)
          .then(({data: {data}}) => {
            this.outgoingNumbers = data;
          })
          .catch(({response}) => {
            this.outgoingNumbers = [];
          });
      },
    },

    created() {
      eventBus.$on('show-quick-chat-message', this.showForm);
    },

    beforeDestroy() {
      eventBus.$off('show-quick-chat-message', this.showForm);
    },
  }
</script>
